<template>
  <div>
    <Header :ifbluech="ifbluech"></Header>
    <breadcrumb :secondhref="secondhref" :secondtest="secondtest"></breadcrumb>
    <div class="content-body body-box" style="overflow: hidden">
      <div class="main-item">
        <div class="body-left">
          <div class="test-box">
            <div class="test-head">
              <span class="test-title">学会人物</span>
            </div>
            <ul style="list-style: none;margin-left: 0px;overflow: hidden">
              <item-character v-for="(p,index) in persons" :key="index" :personName="p.name" :position="p.position" :job="p.job" :img="p.head" :desc="p.desc"></item-character>
            </ul>
            <div class="test-btns">
              <input class="btn" type="button" value="<<" @click="previousPage"/>
              <input class="btn" type="button" v-for="(value, index) in pageSum" :key="index" :value="value" @click="witchPage">
              <input class="btn" type="button" value="..." v-show="pageSum === 11">
              <input class="btn" type="button" value=">>" @click="nextPage"/>
            </div>
          </div>
        </div>
        <!--<div class="body-right">
          <contact></contact>
        </div>-->
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from '@/components/footer/footer.vue'
import Header from '@/components/header/header.vue'
import breadcrumb from '@/components/breadcrumb/breadcrumb.vue'
import contact from '@/components/contact/contact.vue'
import itemCharacter from '@/components/item/itemCharacter.vue'
import HttpServer from '@/utils' // 接口请求
import '../../node_modules/bootstrap/dist/js/bootstrap.js'

export default {
  name: 'character',
  data () {
    return {
      // 所在页面的名称
      topName: 'person',
      // 顶部导航栏
      ifbluech: {
        color: '#0051bd'
      },
      // 面包屑导航栏
      secondhref: '/character',
      secondtest: '学会人物',
      // 总页数
      pageSum: 1,
      // 当前所在页面
      page: 1,
      // 人物列表
      persons: []
    }
  },
  components: {
    Footer: Footer,
    Header: Header,
    breadcrumb: breadcrumb,
    contact: contact,
    itemCharacter: itemCharacter
  },
  mounted () {
    // 调用本页接口
    HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName).then(res => {
      console.log(res)
      this.persons = res.data
      this.pageSum = Math.ceil(res.total / res.page_limit)
      if (this.pageSum > 10) {
        this.pageSum = 11
      }
    })
  },
  methods: {
    // 上一页
    previousPage: function () {
      if (this.page !== 1) {
        this.page--
      }
      HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName + '&page=' + this.page).then(res => {
        this.persons = res.data
      })
    },

    // 下一页
    nextPage: function () {
      if (this.page <= this.pageSum - 1) {
        this.page++
      }
      HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName + '&page=' + this.page).then(res => {
        console.log(res)
        this.persons = res.data
      })
    },

    // 跳转页
    witchPage (event) {
      this.page = +event.target.value
      HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName + '&page=' + this.page).then(res => {
        this.persons = res.data
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @import '../../node_modules/bootstrap/dist/css/bootstrap.css';
  @import 'joinprocess/main.css';
  .body-box{
    margin-top:10px;
    background-color: #f5f5f5;
    min-height: 600px;
  }
  .body-left{
    width: 950px;
    float: left;
  }
  .body-right{
    width: 200px;
    float: right;
  }
  .test-box{
    padding: 12px;
    background-color: #ffffff;
    font-size: 12px;
    text-align: left;
  }
  .test-head{
    height:30px;
    margin-bottom: 15px;
    border-bottom: 1px solid #d7d7d7;
  }
  .test-title{
    font-size: 14px
  }
  .test-btns{
    width: 100%;
    height: 30px;
    text-align: center
  }
  .test-btns input{
    padding: 0px 8px;
    margin: 0px 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/character.vue